import { Button, Input, Space, Table } from "antd";
import React, { useRef, useState } from "react";
import Style from "./OneProductDiscountListTabel.module.scss";
import { SearchOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import { Check2, PencilSquare, XLg } from "react-bootstrap-icons";
import { separate } from "../../../../Utils/SeprateNumber/SeprateThreeNumber";

const OneProductDiscountListTabel = ({ openModal, data }) => {
  const searchInput = useRef(null);
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const getColumnSearchProps = (dataIndex, title) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`جستجو ${title}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            جستجو
          </Button>
          <Button
            onClick={() => handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            پاکسازی
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };
  let dataSource = [];
  let index = 1;
  data &&
    data.forEach((element) => {
      if (element.off_price !== "0") {
        dataSource.push({
          key: index,
          categoryId:element.category_id,
          productId:element.id,
          pName: element.name,
          RPrice: separate(element.price),
          DPrice: separate(element.off_price),
          categoryName:
            element.category_free === null
              ? element.category
              : element.category_free,
        });
      }
      index = index + 1;
    });
  const columns = [
    {
      title: "نام محصول",
      dataIndex: "pName",
      key: "pName",
      width: "20%",
      ...getColumnSearchProps("pName", "نام محصول "),

    },
    {
      title: "نام دسته بندی",
      dataIndex: "categoryName",
      key: "categoryName",
      width: "20%",
      ...getColumnSearchProps("categoryName", "نام دسته بندی "),

    },
    {
      title: "قیمت اصلی",
      dataIndex: "RPrice",
      key: "RPrice",
      width: "20%",
      ...getColumnSearchProps("RPrice", "قیمت اصلی"),
    },
    {
      title: "قیمت  با تخفیف",
      dataIndex: "DPrice",
      key: "DPrice",
      width: "20%",
    },
    {
      title: "عملیات",
      dataIndex: "action",
      key: "action",
      width: "20%",
      render: (text, record) => (
        <div className={Style.btnHolder}>
          <button
            onClick={() => openModal(1, record)}
            className={Style.editBtn}
          >
            <PencilSquare />
          </button>
          <button
              onClick={() => openModal(2, record)}
              className={Style.deleteBtn}
            >
              <XLg />
            </button>
        </div>
      ),
    },
  ];
  return (
    <div style={{ width: "100%" }} className={Style.TabelHolder}>
      <Table
        pagination={{ pageSize: 5 }}
        columns={columns}
        dataSource={dataSource}
        loading={data === undefined ? true : false}
      />
    </div>
  );
};

export default OneProductDiscountListTabel;
